<template>
  <AuthForm @onSignInSuccess="toMainPage" />
</template>

<script lang="ts">
export default {
  name: 'AuthPage',
};
</script>

<script setup lang="ts">
import AuthForm from '@/components/authForm/AuthForm.vue';
import { useRouter } from '@/composables';

const router = useRouter();

function toMainPage() {
  router.push({ name: 'Booking' });
}
</script>

<style scoped>

</style>
